import React, { Component } from 'react'

export default class Process extends Component {
  render() {
    const lessOperator="<";
    const greatOperator=">";
    return (
      <main className="process">
        <section className="process_title">
          <h1>
            <span>{lessOperator}</span> My Process <span>{greatOperator}</span>
          </h1>
        </section>
        <section className="infogram">
          <ul>
            <li >
            <h2>Understand</h2>
              <p>
                meet & learn about the bussiness, stakeholders, goals and needs of the project.Previously done things in the project.
              </p>
              </li>
            <li>
              <h2>Research</h2>
              <p>
                Generating lots of ideas,grasping issues and potential solutions,
                interviewing professionals and more to learn about the industry.
              </p>
            </li>
            <li>
              <h2>Wireframing</h2>
              <p>
               creating as many diferent scinarios and user stories i can create choosing the ones that suits the sutituation most.
              </p>
            </li>
            <li>
              <h2>Evaluate</h2>
              <p>Creating variations of each concept to suit multiple platforms , discover more problems access progress determining next steps</p>
            </li>
            <li>
              <h2>Present</h2>
              <p>Presenting the work to you explain the rationate behind each concept and why they would be successfult.You then provide me with with your feedback.</p>
            </li>
            <li>
              <h2>Deliver</h2>
              <p>Building final project then sening all the files to you in various formats according to directions.</p>
            </li>
          </ul>
        </section>
      </main>
    );
  }
}
